module.exports = __webpack_public_path__ + "static/img/brees-2019-top-image.8de1db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-top-image.jpg
// module id = yGFA
// module chunks = 1